import { render, staticRenderFns } from "./changeRFCNum.vue?vue&type=template&id=fd0edf1a&scoped=true&"
import script from "./changeRFCNum.vue?vue&type=script&lang=js&"
export * from "./changeRFCNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0edf1a",
  null
  
)

export default component.exports